import angular from "angular";
import moment from "moment";

import "moment/locale/de.js";
import "moment/locale/pl.js";

export default angular.module("services.moment",[]).factory("moment",function () {
  return moment;
}).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/moment.js